import '@vebox/etui-system';
import { omit } from '../utilities/omit.js';
import { Component, createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import { T as Td } from '../Td-2423cb3a.js';

function createBodyCell(styles) {
  class BodyCell extends Component {
    constructor(props) {
      super(props);
      this.store = this.props.store;
    }
    render() {
      const props = omit(this.props, ['prefixCls', 'rowKey', 'store']);
      return /*#__PURE__*/createElement(Td, _extends({}, props, styles), this.props.children);
    }
  }
  return BodyCell;
}

export default createBodyCell;
